import styled, { css } from 'styled-components';
import InlineSvg from 'react-inlinesvg';

var StyledInlineSvg = styled(InlineSvg).withConfig({
  displayName: "styles__StyledInlineSvg",
  componentId: "sc-12l8vvi-0"
})(["flex-shrink:0;", ";"], function (props) {
  return props.$shouldScaleDownIcon ? css(["overflow:visible;> *{transform:scale(0.66666);transform-origin:center;}"]) : undefined;
});

export { StyledInlineSvg };
